<template>
    <el-form-item :label="searchName" label-width="90px" >
        <el-input
            placeholder="请输入内容"
            v-model="keywords"
            class="input-with-select selWidth"
            clearable
            @keyup.enter="changeSearch"
       >
            <template #prepend>
                <el-select v-model="prependSelect" placeholder="请选择" style="width: 120px">
                    <el-option
                        v-for="item in searchSelectList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                   />
                </el-select>
            </template>
        </el-input>
    </el-form-item>
</template>

<script lang="ts" setup>
import { ref, reactive, watch } from 'vue';

defineOptions({ name: 'SelectSearch' });

interface SearchOption {
    label: string;
    value: string;
}

interface SearchForm {
    nickname: string;
    uid: string;
    phone: string;
    realName?: string;
    returner?: string;
}

interface Props {
    searchSelectList?: SearchOption[];
    select?: string;
    searchName?: string;
}

const props = withDefaults(defineProps<Props>(), {
    searchSelectList: () => [
        {label: "昵称", value: "nickname"},
        {label: "用户ID", value: "uid"},
        {label: "手机号", value: "phone"},
    ],
    select: 'nickname',
    searchName: '用户搜索：',
});

const emit = defineEmits<{
   search: [searchForm: SearchForm];
}>();

// 用户输入的搜索关键词
const keywords = ref('');

// 当前选中的搜索选项
const prependSelect = ref(props.select);

watch(
  () => props.select,
  (v) => {
    prependSelect.value = v;
  },
);

// 搜索表单数据
const searchForm = reactive<SearchForm>({
    nickname: "",
    uid: "",
    phone: ""
});

// 处理搜索事件
const changeSearch = () => {
    // 重置搜索表单
    Object.assign(searchForm, {
        nickname: "",
        uid: "",
        phone: "",
        realName: "",
        returner: ""
    });

    // 设置当前选中的搜索字段
    searchForm[prependSelect.value as keyof SearchForm] = keywords.value;

    emit('search', searchForm);
};

// 重置参数
const resetParmas = () => {
    keywords.value = "";
    prependSelect.value = props.select;
    changeSearch();
};

// 暴露方法给父组件
defineExpose({
    resetParmas,
    changeSearch
});
</script>

<style scoped lang="scss">
/* 对齐 EB：prepend 内 select 去掉独立边框，避免左边半截复合线 */
.input-with-select {
  :deep(.el-input-group__prepend) {
    background-color: var(--el-fill-color-light, #f5f7fa);
    .el-select .el-select__wrapper {
      box-shadow: none !important;
      background-color: transparent;
      border-radius: 0;
    }
  }
}
.selWidth {
  width: 300px;
}
</style>
